// extracted by mini-css-extract-plugin
export var large = "1084px";
export var medium = "860px";
export var middle = "DashboardHeader-module__middle___P1U6o";
export var small = "540px";